import axios from '@/utils/api.request'
let previousUrl = '/api'

// 根据id查信息
export const getMessageDefault = (id) => {
	return axios.request({
		url: `${previousUrl}/message/${id}`,
		method: 'get'
	})
}

// 已读
export const getListRead = (pageNumber, pageSize) => {
	return axios.request({
		url: `${previousUrl}/message/listRead?page=${pageNumber}&size=${pageSize}`,
		method: 'post'
	})
}

// 设置已读
export const setRead = (id) => {
	return axios.request({
		url: `${previousUrl}/message/read/${id}`,
		method: "get"
	})
}

// 未读
export const getListUnread = (pageNumber, pageSize) => {
	return axios.request({
		url: `${previousUrl}/message/listUnread?page=${pageNumber}&size=${pageSize}&sort=Id,desc`,
		method: 'post'
	})
}
